<mat-toolbar class="subtitulo">Matrícula Secretaria</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <!-- DADOS INICIAIS -->
        <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
 
            <mat-form-field fxFlex="35%" fxFlexOffset="20px">
                <input #descricao matInput maxlength="200" name="descricao" placeholder="Descrição"
                    [(ngModel)]="matriculaSecretaria.descricao" required>
                <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
            </mat-form-field>

            <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                <mat-label>Niveis da turma</mat-label>
                <mat-select [(ngModel)]="matriculaSecretaria.nivelTurma.id" name="nivelTurma" 
                            (selectionChange)="setNivelTurma()">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let u of niveisTurma"
                                [value]="u.id">
                        {{u.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex="10%" fxFlexOffset="20px">
                <mat-label>Turno</mat-label>
                <mat-select [(ngModel)]="matriculaSecretaria.turno" name="turno">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let u of tipoTurno.tipos" [value]="u.id">
                        {{u.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex="35%" fxFlexOffset="20px">
                <mat-label>Selecione a Unidade</mat-label>
                <mat-select name="unidade" [(ngModel)]="matriculaSecretaria.unidade" required>
                    <mat-option *ngFor="let u of unidades" [value]="u">
                        {{ u.nomeUnidade }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            

        </div>

       <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
                    name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary"
                    [disabled]="formCadastro.invalid"
                    (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
                    name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary"
                    [disabled]="formCadastro.invalid"
                    (click)="atualizar()">
                    Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" 
                    mat-raised-button 
                    fxFlex="20%" 
                    (click)="limpar()">
                    Limpar
            </button>
            <button 
                    mat-raised-button 
                    fxFlex="20%" 
                    (click)="cancelar()">
                    Cancelar
            </button>

        </div>
    </form>

</div>
